import { Dictionary } from '@/util/dictionary';
import { ItemCode, itemInfos } from './itemInfos';

export interface BlueprintInfo {
	code: ItemCode,
	result: ItemCode,
	recipe: Array<[number, number]>,
	dismantlable: boolean,
	timeLimited?: boolean,
}

export const blueprintInfos: Dictionary<BlueprintInfo> = {};


let code: ItemCode;
let result: ItemCode;
result = ItemCode.BumpOnHead;
code = ItemCode.BpBumpOnHead;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.HammerheadStone, 20],
		[ItemCode.CopperOre, 10],
		[ItemCode.Money, 1000],
	],
	dismantlable: false,
};
result = ItemCode.Bungalow;
code = ItemCode.BpBungalow;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.BumpOnHead, 3],
		[ItemCode.Money, 1000],
	],
	dismantlable: true,
};
result = ItemCode.Bandaid;
code = ItemCode.BpBandaid;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.HammeredHeadStone, 20],
		[ItemCode.SpinelOre, 10],
		[ItemCode.Money, 1000],
	],
	dismantlable: false,
};
result = ItemCode.BandaidX;
code = ItemCode.BpBandaidX;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Bandaid, 2],
		[ItemCode.Money, 1000],
	],
	dismantlable: true,
};

result = ItemCode.Glasses;
code = ItemCode.BpGlasses;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.BlueSharkStone, 30],
		[ItemCode.QuartzOre, 10],
		[ItemCode.Money, 2000],
	],
	dismantlable: false,
};
result = ItemCode.SpiralGlasses;
code = ItemCode.BpSpiralGlasses;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.WhammyHeadStone, 10],
		[ItemCode.WhammyHeadGem, 1],
		[ItemCode.QuartzOre, 10],
		[ItemCode.AmethystOre, 10],
		[ItemCode.Money, 3000],
	],
	dismantlable: false,
};
result = ItemCode.Monocle;
code = ItemCode.BpMonocle;
blueprintInfos[code] = {
	code,
	result,
	recipe: [

		[ItemCode.KillerWhaleStone, 30],
		[ItemCode.SerialKillerWhaleStone, 10],
		[ItemCode.SerialKillerWhaleGem, 1],
		[ItemCode.QuartzOre, 10],
		[ItemCode.AmethystOre, 10],
		[ItemCode.DiamondOre, 1],
		[ItemCode.Money, 5000],
	],
	dismantlable: false,
};
result = ItemCode.GentlemanMustache;
code = ItemCode.BpGentlemanMustache;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.HammerheadGem, 1],
		[ItemCode.KillerWhaleStone, 30],
		[ItemCode.SerialKillerWhaleStone, 20],
		[ItemCode.SilverOre, 10],
		[ItemCode.CitrineOre, 10],
		[ItemCode.Money, 3000],
	],
	dismantlable: false,
};
result = ItemCode.RedNose;
code = ItemCode.BpRedNose;
blueprintInfos[code] = {
	code,
	result,
	recipe: [

		[ItemCode.KillerWhaleGem, 1],
		[ItemCode.SerialKillerWhaleGem, 1],
		[ItemCode.PsychoKillerWhaleGem, 1],
		[ItemCode.GarnetOre, 10],
		[ItemCode.RubyOre, 1],
		[ItemCode.Money, 10000],
	],
	dismantlable: false,
};
result = ItemCode.Scar1;
code = ItemCode.BpScar1;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.BlueSharkStone, 30],
		[ItemCode.GreatWhiteSharkStone, 20],
		[ItemCode.HammeredHeadGem, 1],
		[ItemCode.AquamarineOre, 10],
		[ItemCode.TurquoiseOre, 10],
		[ItemCode.Money, 3000],
	],
	dismantlable: false,
};
result = ItemCode.ScarX;
code = ItemCode.BpScarX;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Scar1, 2],
		[ItemCode.Money, 1000],
	],
	dismantlable: true,
};
result = ItemCode.Warpaint1;
code = ItemCode.BpWarpaint1;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.BlueSharkStone, 50],
		[ItemCode.GreatWhiteSharkStone, 20],
		[ItemCode.GreatWhiteSharkGem, 1],
		[ItemCode.MegalodonStone, 10],
		[ItemCode.MegalodonGem, 1],
		[ItemCode.Money, 5000],
	],
	dismantlable: false,
};
result = ItemCode.Warpaint2;
code = ItemCode.BpWarpaint2;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Warpaint1, 2],
		[ItemCode.Money, 1000],
	],
	dismantlable: true,
};
result = ItemCode.Warpaint4;
code = ItemCode.BpWarpaint4;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Warpaint2, 2],
		[ItemCode.Money, 1000],
	],
	dismantlable: true,
};

result = ItemCode.BikerSunglasses;
code = ItemCode.BpBikerSunglasses;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.BlueSharkGem, 2],
		[ItemCode.GreatWhiteSharkStone, 20],
		[ItemCode.MegalodonStone, 20],
		[ItemCode.PsychoKillerWhaleStone, 10],
		[ItemCode.CitrineOre, 10],
		[ItemCode.Money, 5000],
	],
	dismantlable: false,
};

result = ItemCode.Saber;
code = ItemCode.BpSaber;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.RankSRock, 1],
		[ItemCode.IronOre, 20],
		[ItemCode.CopperOre, 10],
		[ItemCode.GoldOre, 1],
		[ItemCode.Money, 5000],
	],
	dismantlable: false,
};
result = ItemCode.SharkSaberBlue;
code = ItemCode.BpSharkSaberBlue;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Saber, 1],
		[ItemCode.SharkOrb, 20],
		[ItemCode.GreatWhiteSharkStone, 5],
		[ItemCode.GreatWhiteSharkGem, 3],
		[ItemCode.Money, 10000],
	],
	dismantlable: false,
};
result = ItemCode.SharkSaberRed;
code = ItemCode.BpSharkSaberRed;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Saber, 1],
		[ItemCode.SharkOrb, 20],
		[ItemCode.MegalodonStone, 5],
		[ItemCode.MegalodonGem, 3],
		[ItemCode.Money, 10000],
	],
	dismantlable: false,
};
result = ItemCode.SharkSaberYellow;
code = ItemCode.BpSharkSaberYellow;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Saber, 1],
		[ItemCode.SharkOrb, 20],
		[ItemCode.HammeredHeadStone, 5],
		[ItemCode.HammeredHeadGem, 3],
		[ItemCode.Money, 10000],
	],
	dismantlable: false,
};
result = ItemCode.SharkSaberPurple;
code = ItemCode.BpSharkSaberPurple;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Saber, 1],
		[ItemCode.SharkOrb, 20],
		[ItemCode.WhammyHeadStone, 5],
		[ItemCode.WhammyHeadGem, 3],
		[ItemCode.Money, 10000],
	],
	dismantlable: false,
};


result = ItemCode.BeachBall;
code = ItemCode.BpBeachBall;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.BottlenoseDolphinStone, 20],
		[ItemCode.LapisLazuliOre, 10],
		[ItemCode.Money, 1000],
	],
	dismantlable: false,
};
result = ItemCode.Hoop;
code = ItemCode.BpHoop;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.SpinnerDolphinStone, 30],
		[ItemCode.SpinelOre, 5],
		[ItemCode.LapisLazuliOre, 5],
		[ItemCode.Money, 2000],
	],
	dismantlable: false,
};
result = ItemCode.AmericanFootball;
code = ItemCode.BpAmericanFootball;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.BottlenoseDolphinGem, 1],
		[ItemCode.BottlenoseDolphinStone, 30],
		[ItemCode.CommonDolphinStone, 20],
		[ItemCode.GarnetOre, 10],
		[ItemCode.CitrineOre, 10],
		[ItemCode.Money, 3000],
	],
	dismantlable: false,
};

result = ItemCode.Sword;
code = ItemCode.BpSword;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.RankSRock, 1],
		[ItemCode.IronOre, 20],
		[ItemCode.SilverOre, 10],
		[ItemCode.MythrilOre, 1],
		[ItemCode.Money, 5000],
	],
	dismantlable: false,
};

result = ItemCode.DolphinSwordBlack;
code = ItemCode.BpDolphinSwordBlack;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Sword, 1],
		[ItemCode.DolphinOrb, 20],
		[ItemCode.SerialKillerWhaleStone, 5],
		[ItemCode.SerialKillerWhaleGem, 3],
		[ItemCode.Money, 10000],
	],
	dismantlable: false,
};
result = ItemCode.DolphinSwordPurple;
code = ItemCode.BpDolphinSwordPurple;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Sword, 1],
		[ItemCode.DolphinOrb, 20],
		[ItemCode.PsychoKillerWhaleStone, 5],
		[ItemCode.PsychoKillerWhaleGem, 3],
		[ItemCode.Money, 10000],
	],
	dismantlable: false,
};
result = ItemCode.DolphinSwordTeal;
code = ItemCode.BpDolphinSwordTeal;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Sword, 1],
		[ItemCode.DolphinOrb, 20],
		[ItemCode.CommonDolphinStone, 5],
		[ItemCode.CommonDolphinGem, 3],
		[ItemCode.Money, 10000],
	],
	dismantlable: false,
};
result = ItemCode.DolphinSwordGreen;
code = ItemCode.BpDolphinSwordGreen;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.Sword, 1],
		[ItemCode.DolphinOrb, 20],
		[ItemCode.SpinnerDolphinStone, 5],
		[ItemCode.SpinnerDolphinGem, 3],
		[ItemCode.Money, 10000],
	],
	dismantlable: false,
};

result = ItemCode.BlueCap;
code = ItemCode.BpBlueCap;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.BlueSharkStone, 20],
		[ItemCode.KillerWhaleStone, 20],
		[ItemCode.BottlenoseDolphinStone, 20],
		[ItemCode.Money, 1000],
	],
	dismantlable: false,
};

result = ItemCode.Shield;
code = ItemCode.BpShield;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.RankBRock, 10],
		[ItemCode.LapisLazuliOre, 20],
		[ItemCode.GarnetOre, 10],
		[ItemCode.SapphireOre, 1],
		[ItemCode.Money, 5000],
	],
	dismantlable: false,
};

result = ItemCode.SantaHat;
code = ItemCode.BpSantaHat;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.SpinelOre, 50],
		[ItemCode.IronOre, 50],
		[ItemCode.Money, 1000],
	],
	dismantlable: false,
	timeLimited: true,
};
result = ItemCode.CandyStick;
code = ItemCode.BpCandyStick;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.QuartzOre, 50],
		[ItemCode.IronOre, 50],
		[ItemCode.AmethystOre, 10],
		[ItemCode.Money, 2000],
	],
	dismantlable: false,
	timeLimited: true,
};
result = ItemCode.ReindeerHeadband;
code = ItemCode.BpReindeerHeadband;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.CopperOre, 75],
		[ItemCode.PeridotOre, 75],
		[ItemCode.EmeraldOre, 1],
		[ItemCode.Money, 5000],
	],
	dismantlable: false,
	timeLimited: true,
};
result = ItemCode.StarLantern;
code = ItemCode.BpStarLantern;
blueprintInfos[code] = {
	code,
	result,
	recipe: [
		[ItemCode.SilverOre, 5],
		[ItemCode.GoldOre, 5],
		[ItemCode.Money, 10000],
	],
	dismantlable: false,
	timeLimited: true,
};
// let str = '';
// const dic: Dictionary<number> = {};
// for (const info of Object.values(blueprintInfos)) {
// 	for (const material of info.recipe) {
// 		if (!dic[material[0]]) {
// 			dic[material[0]] = 0;
// 		}
// 		dic[material[0]] += material[1];
// 	}
// }
// for (const itemCode in dic) {
// 	if (Object.prototype.hasOwnProperty.call(dic, itemCode)) {
// 		const amount = dic[itemCode];
// 		const name = itemInfos[itemCode].name;
// 		str += name + '\t' + amount + '\n';
// 	}
// }
// console.log(str);
